module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-900italic.woff?e8d920f5bf6dea0b9fe56768c15fdffd";